export default "__VITE_ASSET__EJY1CeEA__"